import { Transforms } from 'vendor/slate'
import { ELEMENT_TYPES } from 'cg/components/documents/editor/slate/types'
import { v4 as uuidv4 } from 'uuid'

const insertSwagger = (editor, path) => {
  const swagger = {
    type: ELEMENT_TYPES.swagger,
    url: 'https://petstore.swagger.io/v2/swagger.json',
    children: [{ uuid: uuidv4(), text: '', parent: { type: ELEMENT_TYPES.swagger } }]
  }

  Transforms.insertNodes(editor, swagger, { at: path })
}

export { insertSwagger }
